import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const OchranaUdajovPage: React.FC = () => {
  const { t } = useTranslation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="pt-32 md:pt-44 pb-16 px-4">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl md:text-4xl font-bold text-white mb-8">{t('privacy.title')}</h1>

        {/* Company Info */}
        <div className="bg-[#161616] border border-[#2a2a2a] rounded-xl p-6 mb-8">
          <h2 className="text-xl font-semibold text-white mb-4">{t('privacy.controllerTitle')}</h2>
          <div className="grid sm:grid-cols-2 gap-4 text-sm">
            <div>
              <span className="text-gray-500">{t('privacy.companyName')}:</span>
              <p className="text-gray-300">FBS group, s. r. o.</p>
            </div>
            <div>
              <span className="text-gray-500">{t('privacy.regSeat')}:</span>
              <p className="text-gray-300">Tatranská Lomnica 14649, 059 60 Vysoké Tatry</p>
            </div>
            <div>
              <span className="text-gray-500">IČO:</span>
              <p className="text-gray-300">44898487</p>
            </div>
            <div>
              <span className="text-gray-500">DIČ:</span>
              <p className="text-gray-300">2022869717</p>
            </div>
          </div>
        </div>

        <div className="space-y-8 text-gray-300 text-sm leading-relaxed">
          <section>
            <h2 className="text-lg font-semibold text-white mb-3">{t('privacy.section1Title')}</h2>
            <p>{t('privacy.section1Text')}</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-3">{t('privacy.section2Title')}</h2>
            <p>{t('privacy.section2Text')}</p>
            <ul className="list-disc list-inside mt-2 space-y-1 text-gray-400">
              <li>{t('privacy.section2item1')}</li>
              <li>{t('privacy.section2item2')}</li>
              <li>{t('privacy.section2item3')}</li>
              <li>{t('privacy.section2item4')}</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-3">{t('privacy.section3Title')}</h2>
            <p>{t('privacy.section3Text')}</p>
            <ul className="list-disc list-inside mt-2 space-y-1 text-gray-400">
              <li>{t('privacy.section3item1')}</li>
              <li>{t('privacy.section3item2')}</li>
              <li>{t('privacy.section3item3')}</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-3">{t('privacy.section4Title')}</h2>
            <p>{t('privacy.section4Text')}</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-3">{t('privacy.section5Title')}</h2>
            <p>{t('privacy.section5Text')}</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-3">{t('privacy.section6Title')}</h2>
            <p>{t('privacy.section6Text')}</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-3">{t('privacy.section7Title')}</h2>
            <p>{t('privacy.section7Text')}</p>
            <p className="mt-2 text-gray-400">Email: info@fbsgroup.sk</p>
          </section>

          <div className="border-t border-[#2a2a2a] pt-6 text-gray-500 text-xs">
            {t('privacy.lastUpdated')}: 13.03.2026
          </div>
        </div>
      </div>
    </div>
  );
};

export default OchranaUdajovPage;
